import { BookingType } from "../../Booking-Form/typings/booking-inputs";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import type { Dashboard2BookingParticipantTag } from "../types/dashboard2-work-status.types";

export function resolveScheduleParticipantTags(
  schedule: BookingScheduleInterface
): Dashboard2BookingParticipantTag[] {
  const isVisitorManaged =
    schedule.isVisitOnly === true ||
    schedule.bookingType === BookingType.VISITOR ||
    schedule.external === true ||
    (schedule.visitorBookings?.length ?? 0) > 0;

  if (isVisitorManaged) {
    return ["visitor"];
  }

  if (
    (schedule.externalBooking === true || schedule.isGuest === true) &&
    Boolean(schedule.externalName?.trim() || schedule.externalEmail?.trim())
  ) {
    return ["external"];
  }

  return [];
}

export function participantTagTranslationKey(
  tag: Dashboard2BookingParticipantTag
): "Visitor" | "_dashboard2_bookingParticipantTagExternal" {
  return tag === "visitor" ? "Visitor" : "_dashboard2_bookingParticipantTagExternal";
}

/** Drop participant tags already conveyed by the booking type label (e.g. Visitor type). */
export function filterRedundantParticipantTags(
  typeLabel: string | undefined,
  tags: readonly Dashboard2BookingParticipantTag[]
): Dashboard2BookingParticipantTag[] {
  const normalizedType = typeLabel?.trim().toLowerCase();

  return tags.filter(tag => {
    if (tag === "visitor" && normalizedType === "visitor") {
      return false;
    }

    if (tag === "external" && normalizedType === "external") {
      return false;
    }

    return true;
  });
}
